import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { earningListing, viewEarningDetailsApi } from "../apis/apiHandler";

export const allEarnings = createAsyncThunk(
    'earnings/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await earningListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewEarningDetails = createAsyncThunk(
    'earnings/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewEarningDetailsApi(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    earningList: [],
    error: null,
    earningDetail: {},
    statusSuccess: false
};

const earningSlice = createSlice({
    name: 'earning',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allEarnings.pending, (state) => {
                state.loading = true;
            })
            .addCase(allEarnings.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.earningList = payload?.data;
            })
            .addCase(allEarnings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(viewEarningDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewEarningDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.earningDetail = payload?.data;
            })
            .addCase(viewEarningDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

export default earningSlice.reducer;